import React from 'react';
import ComingSoon from '../ComingSoon';

const TomDelivery = () => {
  return <ComingSoon featureName="TOM Delivery" />;
};

export default TomDelivery; 